import { CryptoJsService } from './../../services/crypto-js.service';
import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Message, MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import * as CryptoJS from 'crypto-js';
import { MenuService } from 'src/app/services/app.menu.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { JEService } from 'src/app/services/je-services.service';

@Component({
  selector: 'app-vendor-registration',
  templateUrl: './vendor-registration.component.html',
  styleUrls: ['./vendor-registration.component.scss']
})
export class VendorRegistrationComponent implements OnInit {
  isOTPSend: boolean = false;
  phoneNo: string;
  otp: string;
  public onAuthForm: FormGroup;
  submitted: boolean;
  validationOTP: any;
  btnDisabled: boolean = false;
  display: any;
  isSiteUnderMaintenance: boolean = false;

    constructor(
      private authService: AuthenticationService,
      private service: MessageService,
      private _formBuilder: FormBuilder,
      public router: Router,
      private farmersDetailsService: FarmersDetailsService,
      private cryptoJS: CryptoJsService,
      private menuService: MenuService,
      private activityRecordService: ActivityRecordService,
      private cryptoJs: CryptoJsService,
      private loader: AppLoaderService,
      private jeService: JEService,
      private cryptoJsService: CryptoJsService,
    ) { }

  ngOnInit(): void {
    this.getInitialToken();

    this.onAuthForm = this._formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
      remembercheck: ['', []],
    });
    // this.f.otp.disable();
    // this.vendorData();
  }

  getInitialToken(){
    this.authService
      .getInitialToken()
      .pipe(first())
      .subscribe({
        next: (response) => {
          if (response){
            sessionStorage.setItem("token", response.data)
          }
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: `Next level user not found. ${err}`,
          // });
        },
      });
  }

  get f() {
    return this.onAuthForm.controls;
  }

  login() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.onAuthForm.invalid) {
      this.activityRecordService.activityRecord(this.onAuthForm.controls.email.value, 'vendor_login', '', new Date(), 'Invalid Login');

      this.service.add({ severity: 'error', summary: 'Error Message', detail: "Invalid Input" });
      return;
    }
    let body = {
      "email": this.cryptoJS.Encrypt(this.onAuthForm.controls.email.value),
      "password": this.cryptoJS.Encrypt(this.onAuthForm.controls.password.value)
    }

    let reqBody = {
      email_ID: this.f.email.value,
      password: this.cryptoJS.Encrypt(this.f.password.value)
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.authService.vendorLogin(reqBodyAfterEncypt).pipe(first())
      .subscribe({
        next: (resp: any) => {
          sessionStorage.setItem("token", resp.data);
          let data = JSON.parse(this.cryptoJsService.DecryptToken(resp.data));
          this.loader.close();
          this.activityRecordService.activityRecord(this.f.email.value, 'Vendor Reg Login', '', new Date(), 'Success', reqBodyAfterEncypt);

          const loginDetails = new Map();
          loginDetails.set('tokenInfo', data);

          // this.router.navigate(['/new-registration']);
          if (data?.authToken) {
            loginDetails.set('vendorUser', this.f.email.value);
            loginDetails.set('userID', 'vendorReg');
            loginDetails.set('isNewRegLogin', '1');
           
            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));
            
            this.router.navigate(['/new-registration']);

          }

        },
        error: (err) => {
          this.loader.close();

          let errorArray = err;
          this.activityRecordService.activityRecord(this.f.email.value, 'Vendor Reg Login(Error)', '', new Date(), errorArray[0], reqBodyAfterEncypt);

          if (errorArray.length) {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: errorArray[0] });
          } else {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! userid or password not correct.' });
          }
        }
      });

  }


  reloadPage() {
    window.location.reload();
  }

  goBack() {
    window.history.back();
  }
  signUP() {
    this.router.navigate(['/vendor-reg-signup']);
  }
}


